import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2Icon, ZapIcon, ShieldCheckIcon, ActivityIcon } from 'lucide-react';
export function PricingPage() {
  return <div className="flex flex-col pb-24" data-id="element-963">
      {/* Promo Banner */}
      <div className="bg-pk-indigo-light border-b border-pk-indigo/20 py-3 px-4 text-center" data-id="element-964">
        <p className="text-sm font-medium text-pk-indigo-dark" data-id="element-965">
          🎉 Launch special: Get 50% off setup with code{' '}
          <span className="font-mono bg-white px-2 py-0.5 rounded border border-pk-indigo/20 ml-1" data-id="element-966">
            LAUNCH50
          </span>
        </p>
      </div>

      {/* Hero */}
      <section className="pt-20 pb-16 px-4 text-center" data-id="element-967">
        <div className="container mx-auto max-w-4xl" data-id="element-968">
          <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-969">
            Simple, transparent pricing
          </h1>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto" data-id="element-970">
            Pay once for expert configuration. Add monitoring for ongoing peace
            of mind.
          </p>
        </div>
      </section>

      {/* Pricing Cards */}
      <section className="px-4 mb-24" data-id="element-971">
        <div className="container mx-auto max-w-6xl" data-id="element-972">
          <div className="grid md:grid-cols-3 gap-8 items-stretch" data-id="element-973">
            {/* Free Tier */}
            <div className="bg-card border border-border rounded-2xl p-8 flex flex-col" data-id="element-974">
              <div className="w-12 h-12 rounded-lg bg-muted flex items-center justify-center mb-6" data-id="element-975">
                <ZapIcon className="w-6 h-6 text-foreground" data-id="element-976" />
              </div>
              <h3 className="text-2xl font-bold mb-2" data-id="element-977">Free</h3>
              <p className="text-muted-foreground mb-6 h-12" data-id="element-978">
                Configuration & Recommendation
              </p>
              <div className="text-4xl font-bold mb-8" data-id="element-979">$0</div>
              <ul className="space-y-4 mb-8 flex-1" data-id="element-980">
                <li className="flex items-start gap-3" data-id="element-981">
                  <CheckCircle2Icon className="w-5 h-5 text-muted-foreground shrink-0" data-id="element-982" />
                  <span data-id="element-983">Guided questionnaire</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-984">
                  <CheckCircle2Icon className="w-5 h-5 text-muted-foreground shrink-0" data-id="element-985" />
                  <span data-id="element-986">Architecture recommendation</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-987">
                  <CheckCircle2Icon className="w-5 h-5 text-muted-foreground shrink-0" data-id="element-988" />
                  <span data-id="element-989">Preview Stripe modules</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-990">
                  <CheckCircle2Icon className="w-5 h-5 text-muted-foreground shrink-0" data-id="element-991" />
                  <span data-id="element-992">Data model preview</span>
                </li>
              </ul>
              <Link to="/setup" className="w-full block text-center bg-muted text-foreground hover:bg-muted/80 px-6 py-3 rounded-lg font-medium transition-colors" data-id="element-993">
                Start Free Setup
              </Link>
            </div>

            {/* Setup Tier */}
            <div className="bg-card border-2 border-primary rounded-2xl p-8 flex flex-col relative shadow-xl scale-105 z-10" data-id="element-994">
              <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-primary text-primary-foreground px-4 py-1 rounded-full text-sm font-medium" data-id="element-995">
                Most Popular
              </div>
              <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center mb-6" data-id="element-996">
                <ShieldCheckIcon className="w-6 h-6 text-primary" data-id="element-997" />
              </div>
              <h3 className="text-2xl font-bold mb-2" data-id="element-998">Setup</h3>
              <p className="text-muted-foreground mb-6 h-12" data-id="element-999">
                Provisioning & Implementation Pack
              </p>
              <div className="flex items-end gap-2 mb-8" data-id="element-1000">
                <span className="text-4xl font-bold" data-id="element-1001">$29</span>
                <span className="text-muted-foreground mb-1" data-id="element-1002">one-time</span>
              </div>
              <ul className="space-y-4 mb-8 flex-1" data-id="element-1003">
                <li className="flex items-start gap-3" data-id="element-1004">
                  <CheckCircle2Icon className="w-5 h-5 text-primary shrink-0" data-id="element-1005" />
                  <span data-id="element-1006">Everything in Free</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-1007">
                  <CheckCircle2Icon className="w-5 h-5 text-primary shrink-0" data-id="element-1008" />
                  <span data-id="element-1009">Automated Stripe provisioning</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-1010">
                  <CheckCircle2Icon className="w-5 h-5 text-primary shrink-0" data-id="element-1011" />
                  <span data-id="element-1012">Custom implementation pack</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-1013">
                  <CheckCircle2Icon className="w-5 h-5 text-primary shrink-0" data-id="element-1014" />
                  <span data-id="element-1015">Database schema & code snippets</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-1016">
                  <CheckCircle2Icon className="w-5 h-5 text-primary shrink-0" data-id="element-1017" />
                  <span data-id="element-1018">Test & Go-Live checklists</span>
                </li>
              </ul>
              <Link to="/setup" className="w-full block text-center bg-primary text-primary-foreground hover:opacity-90 px-6 py-3 rounded-lg font-medium transition-opacity" data-id="element-1019">
                Get Started
              </Link>
            </div>

            {/* Monitoring Tier */}
            <div className="bg-card border border-border rounded-2xl p-8 flex flex-col" data-id="element-1020">
              <div className="w-12 h-12 rounded-lg bg-pk-info-light flex items-center justify-center mb-6" data-id="element-1021">
                <ActivityIcon className="w-6 h-6 text-pk-info" data-id="element-1022" />
              </div>
              <h3 className="text-2xl font-bold mb-2" data-id="element-1023">Monitoring</h3>
              <p className="text-muted-foreground mb-6 h-12" data-id="element-1024">
                Ongoing health & drift alerts
              </p>
              <div className="flex items-end gap-2 mb-8" data-id="element-1025">
                <span className="text-4xl font-bold" data-id="element-1026">$19</span>
                <span className="text-muted-foreground mb-1" data-id="element-1027">/mo</span>
              </div>
              <p className="text-sm text-muted-foreground mb-6 -mt-4" data-id="element-1028">
                $9/mo per additional account
              </p>
              <ul className="space-y-4 mb-8 flex-1" data-id="element-1029">
                <li className="flex items-start gap-3" data-id="element-1030">
                  <CheckCircle2Icon className="w-5 h-5 text-pk-info shrink-0" data-id="element-1031" />
                  <span data-id="element-1032">Webhook health monitoring</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-1033">
                  <CheckCircle2Icon className="w-5 h-5 text-pk-info shrink-0" data-id="element-1034" />
                  <span data-id="element-1035">Configuration drift alerts</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-1036">
                  <CheckCircle2Icon className="w-5 h-5 text-pk-info shrink-0" data-id="element-1037" />
                  <span data-id="element-1038">Stripe update recommendations</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-1039">
                  <CheckCircle2Icon className="w-5 h-5 text-pk-info shrink-0" data-id="element-1040" />
                  <span data-id="element-1041">Dashboard access</span>
                </li>
              </ul>
              <Link to="/setup" className="w-full block text-center bg-background border border-border text-foreground hover:bg-muted px-6 py-3 rounded-lg font-medium transition-colors" data-id="element-1042">
                Add during setup
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="px-4" data-id="element-1043">
        <div className="container mx-auto max-w-3xl" data-id="element-1044">
          <h2 className="text-2xl font-bold mb-8 text-center" data-id="element-1045">Pricing FAQ</h2>
          <div className="space-y-6" data-id="element-1046">
            <div data-id="element-1047">
              <h4 className="font-semibold mb-2" data-id="element-1048">
                When do I pay the $29 setup fee?
              </h4>
              <p className="text-muted-foreground" data-id="element-1049">
                You only pay after you've completed the questionnaire and
                reviewed your recommended stack. The preview is completely free.
              </p>
            </div>
            <div data-id="element-1050">
              <h4 className="font-semibold mb-2" data-id="element-1051">
                How does the LAUNCH50 discount work?
              </h4>
              <p className="text-muted-foreground" data-id="element-1052">
                Enter the code LAUNCH50 during the checkout step to get 50% off
                the one-time setup fee, bringing it down to $14.50.
              </p>
            </div>
            <div data-id="element-1053">
              <h4 className="font-semibold mb-2" data-id="element-1054">
                Is the monitoring plan required?
              </h4>
              <p className="text-muted-foreground" data-id="element-1055">
                No, monitoring is completely optional. You can provision your
                stack for a one-time fee and never pay us again. Monitoring is
                for teams who want ongoing alerts if their Stripe configuration
                changes or webhooks fail.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>;
}